<script lang="typescript">
    import { createEventDispatcher } from "svelte";

    export let id = "input";
    export let value = "";
    export let name = "name";
    export let placeholder = "My Input";
    export let disabled = false;
    let i = disabled;
    $: {
        i = disabled;
    }
    export let label = "Input Label";
    export let bg = "var(--color-level-1)";
    export let type: "text" | "password" = "text";
    export let autocomplete: "on" | "off" = "off";
    export let width = "100%";

    const dispatch = createEventDispatcher();

    let focused = false;
    const onFocus = () => (focused = true);
    const onBlur = () => (focused = false);

    const handleInput = (e: any) => {
        // in here, you can switch on type and implement
        // whatever behaviour you need
        value = type.match(/^(number|range)$/)
            ? +e.target.value
            : e.target.value;

        dispatch("input", { value });
    };
</script>

<div class="input-textarea">
    <label
        style="background: {bg};"
        class:focused
        class="input-label"
        {disabled}
        for={name}>{label}</label
    >

    <textarea
        {id}
        {name}
        {value}
        style="background: {bg}; width: {width};"
        class:focused
        class="textarea"
        {type}
        {placeholder}
        on:input={handleInput}
        on:change
        {disabled}
        on:focus={onFocus}
        on:blur={onBlur}
        {autocomplete}
    />
</div>

<style>
    /*  
    --color-level-0: #1e1e1e;
    --color-level-1: #2c2c2c;
    --color-level-2: #393939;
    --color-level-3: #595959;
    --color-level-4: #666666;
    --color-level-5: #808080;
    --color-level-6: #b7b7b7;
    --color-level-7: #efefef; 
    */
    :root {
        --txtarea-border-color: var(--color-level-3, #595959);
        --txtarea-color: var(--color-level-7, #b7b7b7);
        --txtarea-active-color: var(--color-primary, #bb86fc);
        --txtarea-disabled-color: var(--color-level-5, #595959);
    }

    .input-textarea {
        position: relative;
        min-height: 74px;
        display: flex;
        flex-grow: 1;
    }
    .input-label {
        position: absolute;
        top: -5px;
        left: 10px;
        font-size: 12px;
        color: var(--txtarea-color);
        padding: 0 6px;
        z-index: 1;
    }
    .textarea {
        border-radius: 4px;
        border: 2px solid var(--txtarea-color);
        height: 56px;
        width: 328px;
        font-size: 14px;
        background: transparent;
        color: var(--txtarea-color);
        padding: 16px;
        outline: none !important;

        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
    }
    .textarea:focus {
        border: 2px solid var(--txtarea-active-color);
    }
    .focused {
        color: var(--txtarea-active-color);
    }

    .textarea[disabled="true"] {
        border: 2px solid var(--txtarea-disabled-color);
        color: var(--txtarea-disabled-color);
    }
    .input-label[disabled="true"] {
        color: var(--txtarea-disabled-color);
    }
</style>
